import { LINE_URL } from "./contact";

//—— 導覽設定 ——
//  抽成 constant 的理由：頂部分類列、抽屜選單、footer、底部 tab bar 會用到同一份，
//  寫死在各元件裡會出現好幾份不同步的清單。

//頂部分類列
//  path 之後對應各分類頁；目前只有首頁有實作，其餘先導向首頁不會壞掉。
export const CATEGORY_TABS = [
  { key: "home", label: "首頁", path: "/" },
  { key: "love", label: "戀愛", path: "/category/love" },
  { key: "wealth", label: "財運", path: "/category/wealth" },
  { key: "career", label: "事業", path: "/category/career" },
  { key: "match", label: "合盤", path: "/category/match" },
  { key: "general", label: "綜合", path: "/category/general" },
];

//底部 tab bar
//  icon 用 inline SVG（見 bottom-tab-bar.js），不引 icon 套件：
//  只有四個圖示，為此多載一包 library 不划算。
//
//  「探索」就是首頁（path "/"）—— 首頁本身的內容是逛服務，
//  用「探索」比「首頁」更貼近使用者在那頁做的事。
//  needAuth 的項目未登入時不會導頁，而是在原地跳登入彈窗（見 context/login-gate）。
//  authMessage 是彈窗上的情境說明 —— 講清楚「登入之後能做什麼」，
//  比一句泛泛的「請先登入」更容易讓人願意登入。
export const BOTTOM_TABS = [
  { key: "explore", label: "探索", path: "/" },
  //  問卦與提問**不擋登入**（Kevin 2026-10-08 決定）。
  //  擋在門口的話，使用者連那一頁長什麼樣都還沒看到就被要求登入 ——
  //  他沒有理由答應。改成讓他先進去、先看到伏爻子，等他真的要打字
  //  （focus 輸入框）才跳登入，那時候他已經想問了。
  //  實際的攔截點在 pages/fuyaozi-ask/chat 與 pages/baiye-question/chat。
  { key: "ask", label: "問卦", path: "/ask" },
  //搜尋不再佔一個頁籤 —— 它的入口是首頁頂部那顆放大鏡（見 nav/nav-list）。
  //  四個位子是全站最貴的版位，讓給使用者真的會反覆回來的事。
  //
  //  提問由白夜接（pages/baiye-question），問卦由伏爻子接（pages/fuyaozi-ask）。
  //  兩邊原本是同一支元件吃不同 persona，2026-10-07 拆開了。
  //  同問卦，這一頁也不擋登入。
  { key: "question", label: "提問", path: "/question" },
  {
    key: "mine",
    label: "我的",
    path: "/account",
    needAuth: true,
    authMessage: "登入後即可查看你的報告、優惠券與個人資料。",
  },
];

//footer 連結
//  三種去處，一筆只會有其中一個：
//    doc   開條款 dialog（componments/dialog/policy-dialog 的 doc 值）
//    href  站外連結（另開分頁）
//    path  導到站內某一頁
//
//  條款走 dialog 而不是 /policy 頁面：全站的法律條文都寫在那支 dialog 裡
//  （購買彈窗也是從那裡出來的），再做一頁等於同一份條文有兩個來源，
//  改了一邊沒改另一邊的那天，不一致會出現在法律文件上。
//
//  「聯絡客服」不在這裡 —— 它搬到頁尾的「聯絡」區塊，跟客服信箱、
//  服務時間放在一起（Kevin 2026-10-20）。那裡本來就寫著同一個信箱，
//  分開放會變成「同一件事講兩次，而且其中一個點了沒反應」。
//
//  「常見問題」也拿掉了（同日）：它指向 /faq，而那條 route 不存在 ——
//  與其留一條白頁連結等哪天補，不如換成真的有人在另一頭的管道。
//
//  LINE_URL 見 constant/contact（已是實際的官方帳號）。兩支購票元件
//  也指著同一個常數，填好那一處就三個地方一起生效。
export const FOOTER_LINKS = [
  { label: "使用條款", doc: "terms" },
  { label: "隱私權政策", doc: "privacy" },
  { label: "官方LINE客服", href: LINE_URL },
];
